import Keycloak from 'keycloak-js';
import { ENV } from './config';

const keycloak = new Keycloak({
  url: ENV.REACT_APP_KEYCLOAK_URL,
  realm: ENV.REACT_APP_KEYCLOAK_REALM,
  clientId: ENV.REACT_APP_KEYCLOAK_CLIENTID
});

export default keycloak;